export const defaultStyle =
  "hidden py-1 px-3 text-xs disabled:opacity-50 disabled:cursor-not-allowed text-dark border-t border-b border-primary bg-primary hover:bg-secondary";
